import { Component } from '@angular/core';
import { AuthService } from '../auth.service';

@Component({
    selector: 'update-email',
    templateUrl: './update-email.component.html',
    styleUrls: ['./update-email.component.css'],
    standalone: false
})
export class UpdateEmailComponent {

  currentEmail: string;
  newEmail: string;
  confirmEmail: string;
  password: string;
  emailSent: boolean = false;

  constructor(private authService: AuthService){

  }

  init(){
    this.currentEmail = '';
    this.newEmail = '';
    this.confirmEmail = '';
    this.password = '';
  }


  async updateEmail(){
    let response = await this.authService.emailUpdateRequest(this.currentEmail, this.newEmail, this.confirmEmail, this.password);
    if(response){
      this.emailSent = true;
      this.authService.openSnackBar('Email has been sent!','Ok');

      this.init();
      setTimeout(() =>{ this.emailSent = false; }, 5000);

      return;
    }

    this.authService.openSnackBar('There was an issue sending email', 'Ok');

  }

}
